export default "__VITE_ASSET__C8p3avii__"